import { HOST } from "common-import/constants";
import { observable, autorun } from "mobx";
import { Request, MobXHelper, VarHelper } from "common-import/helpers";
const compareVersions = require('compare-versions');
const { makePersit } = MobXHelper;
const GlobalEvent = require('js-events-listener');

const SHEET_API = field => "https://script.google.com/macros/s/AKfycbz2mwvpAYUjvP4c4qF00czzBM86ZM0_-cnI6-WlvKHQh9gSbn8/exec?field="+field;
// const SERVER_API = field => "http://web.houselink.com.vn:4444/utils/update-master-data?field="+field;
// const SERVER_API_ALL = "http://web.houselink.com.vn:4444/utils/update-master-data";

const SERVER_API = field => "https://s4.dev.houselink.info/utils/update-master-data?field_format=array&field="+field;
const SERVER_API_ALL = "https://s4.dev.houselink.info/utils/update-master-data?field_format=array";

class FieldStore {
  
  constructor(isServer, initialData) {
    if(isServer) {
      for (let key in initialData) {
        this[key] = initialData[key];
      }
    } else {
      this.loadInitialData();
    }
  }

  @observable master_data_version = {};

  @observable contractor_type = [];
  @observable contractor_company_type = [];
  @observable contractor_sub_type = [];
  @observable project_type = [];
  @observable project_sub_type = [];
  @observable project_state = [];
  @observable project_state_status = [];
  @observable project_work_type = [];
  @observable project_investment_type = [];
  @observable project_investment_type_app = [];
  @observable project_purpose = [];
  @observable project_budget = [];
  @observable project_construction_area = [];
  @observable project_land_area = [];
  @observable product_categories = [];
  @observable product_sub_categories = [];
  @observable product_type = [];
  @observable project_company_role = [];
  @observable index_review_name = [];
  @observable index_review_content = [];
  @observable country = [];
  @observable product_categories_lev3 = [];
  @observable order_status = [];

  convertArrayToObject = (fieldArray) => {
    /*
      from 
      [{id, en, vi, img}]
      to
      { en: {}, vi: {}, img: {}}
    */

    let result = { en: {}, vi: {}, img: {}};
    fieldArray.forEach((val) => {
      if (val.id === '') return;
      result.en[val.id] = val.en;
      result.vi[val.id] = val.vi;
      if (!!val.img) {
        result.img[val.id] = val.img;
      }
    });
    return result;
  }

  ready = false;

  loadInitialData = async () => {
    autorun(() => {
      console.log('autorun lang', this.lang);
      makePersit.make(this.lang, "lang");
    });
    this.langReady = true;
    GlobalEvent.emit("LANG_READY");

    let master_data_version = await makePersit.persist("master_data_version", "object");
    if (master_data_version != undefined) this.master_data_version = master_data_version;
    const forced = await this.getMasterDataVersion();

    const arr = [
      "contractor_type", "contractor_company_type", "contractor_sub_type", "project_type", "project_sub_type",
      "project_state", "project_state_status", "project_work_type", "project_investment_type", "project_investment_type_app", "project_purpose",
      "project_budget", "project_construction_area", "project_land_area", "product_categories", "product_sub_categories",
      "product_type", "project_company_role", "index_customer_review", "our_people", "country", "product_categories_lev3", "order_status", 
    ];
    await this.syncDataServer(arr, forced);
    this.ready = true;
    GlobalEvent.emit("FIELD_STORE_READY");
  }

  onReady = callback => new Promise((resolve, reject) => {
    const run = () => {
      typeof callback === 'function' && callback();
      resolve();
    }
    if (this.ready) run();
    else GlobalEvent.on("FIELD_STORE_READY", run);
  });

  findID = (fieldArray, fieldValue) => {
    const fieldObject = this.convertArrayToObject(fieldArray);
    let dataVi = fieldObject.vi;
    let dataEn = fieldObject.en;
    if (fieldObject.en === undefined) return "-1";
    let idArr = Object.keys(fieldObject.en);
    let length = idArr.length;
    for (let i=0; i<length; i++) {
      if(dataVi[idArr[i]] == fieldValue || dataEn[idArr[i]] == fieldValue) {
        return idArr[i];
      }
    }

    return "-1";
  }

  toTreeLevelData = (parentArray, childArray) => {
    const parentObject = this.convertArrayToObject(parentArray);
    const childObject = this.convertArrayToObject(childArray);
    if (parentObject == undefined || childObject == undefined) return [];
    /*
    [
      {
        id: "1", label: "", value:"", img: "", children: [
          { id: "1.1", label: "", value:"", img: "" }
        ]
      }
    ]
    */
    let result = [];

    let parent = parentObject[this.lang];
    let parentImg = parentObject.img || {};
    let child = childObject[this.lang];
    let childImg = childObject.img || {};
    if (parent == undefined || child == undefined) return [];

    let keyArrChild = Object.keys(child);

    for (let key in parent ) {
      let oneParent = { id: key, label: parent[key], value: parent[key], img: parentImg[key] };
      oneParent.children = [];
      let firstDotId = key + ".";
      keyArrChild.forEach(val => {
        if(val.indexOf(firstDotId) === 0) {
          oneParent.children.push({ id: val, label: child[val], value: child[val], img: childImg[val] })
        }
      });
      result.push(oneParent);
    }

    return result;
    
  }

  toSelectLabelObject = (fieldArray) => (valueOrId) => {
    const fieldObject = this.convertArrayToObject(fieldArray);
    // handle value first
    let dataEn = fieldObject.en;
    let dataVi = fieldObject.vi;
    for (let key in dataEn) {
      if(valueOrId === key) return { value: dataEn[key], label: fieldObject[this.lang][key] };
      if(dataEn[key] === valueOrId) return { value: dataEn[key], label: fieldObject[this.lang][key] };
      if(dataVi[key] === valueOrId) return { value: dataEn[key], label: fieldObject[this.lang][key] };
    }
  }

  toValue = (fieldArray, valueOrId) => {
    const fieldObject = this.convertArrayToObject(fieldArray);
    if (!fieldObject) return valueOrId;
    if(!fieldObject[this.lang]) return valueOrId;
    let data = VarHelper.valueBecameKey(fieldObject[this.lang]);
    // console.log(data);
    return data[valueOrId] || valueOrId;
  }

  toObject = (fieldArray) => {
    const fieldObject = this.convertArrayToObject(fieldArray);
    if(!fieldObject[this.lang]) return {};
    console.log('toObject', fieldObject[this.lang]);
    return fieldObject[this.lang];
  }

  toListWithImage = (fieldArray) => {
    // const fieldObject = this.convertArrayToObject(fieldArray);
    // if(!fieldObject[this.lang]) return [];
    // let data = fieldObject[this.lang];
    // let imgData = !!fieldObject.img ? fieldObject.img : {};
    // let result = [];
    // return Object.keys(data).map(item => ({ id: item, label: data[item], img: imgData[item], value: fieldObject.en[item] }));
    return fieldArray.map(val => ({ ...val, value: val.en, label: val[this.lang] }))
  }

  toSelectData = (fieldArray) => {
    // const fieldObject = this.convertArrayToObject(fieldArray);
    // if(!fieldObject[this.lang]) return [];
    // let data = fieldObject[this.lang];
    // let result = [];
    // return Object.keys(data).map(item => ({ id:item, value: fieldObject.en[item], label: data[item] }));
    return fieldArray.map(val => ({ ...val, value: val.en, label: val[this.lang] }))
  }

  toSelectMoneyData = (fieldArray) => {
    const fieldObject = this.convertArrayToObject(fieldArray);
    if(!fieldObject[this.lang]) return [];
    let data = fieldObject[this.lang];
    let result = [];
    return Object.keys(data).map(item => ({ value: fieldObject.en[item], label: data[item].replace(/\,000\,000\,000\,000/g, ' nghìn tỷ').replace(/\,000\,000\,000/g, ' tỷ') }));
  }

  toSelectDataWithFilter = (firstDotId) => (fieldArray) => { // like "1.1", "1.2", filter all "1.*"
    const fieldObject = this.convertArrayToObject(fieldArray);
    if(!fieldObject[this.lang]) return [];
    let data = fieldObject[this.lang];
    let imgData = !!fieldObject.img ? fieldObject.img : {};
    return Object.keys(data).filter(item => item.indexOf(firstDotId) === 0).map(item => ({ id: item, value: fieldObject.en[item], label: data[item], img: imgData[item] }));
  }

  toSelectDataWithFilterId = (id) => {
    if (typeof id !== 'string') return this.toSelectDataWithFilter("");
    if (!id) return this.toSelectDataWithFilter("");
    return this.toSelectDataWithFilter(id.split(".")[0] + ".");
  }

  getMatchArray = (field) => {
    switch(field) {
      case 'project': return [
        { field: 'projectType', md: 'project_type' },
        { field: 'projectSubType', md: 'project_sub_type' },
        { field: 'purpose', md: 'project_purpose' },
        { field: 'investmentType', md: 'project_investment_type_app' },
        { field: 'workType', md: 'project_work_type' },
        { field: 'state', md: 'project_state' },
        { field: 'status', md: 'project_state_status' },
      ];

      case 'professional': return [
        { field: 'typeOfCompany', md: 'contractor_company_type' },
        { field: 'typeOfContractor', md: 'contractor_type' },
        { field: 'typeOfConstruction', md: 'contractor_sub_type' },
      ];
      
    }
  }

  convertValueToId = (matchArray) => (dataObject) => {
    // matchArray = [
    //   { field: 'purpose', md: this.project_purpose },
    // ];
    console.log(dataObject);
    let newDataObject = { ...dataObject };
    matchArray.forEach(val => {
      if (!val.field) return;
      const id = this.findID(this[val.md], newDataObject[val.field]);
      newDataObject[val.field] = id === "-1" ? newDataObject[val.field] : id;
    });
    return newDataObject;
  }

  getValueFromId = (fieldArray) => (id) => {
    const fieldObject = this.convertArrayToObject(fieldArray);
    if(!fieldObject[this.lang]) return id;
    let data = fieldObject[this.lang];
    console.log('getValueFromId', { id, value: fieldObject.en[id] || id, label: data[id] || id });
    return { id, value: fieldObject.en[id] || id, label: data[id] || id };
  }

  getMasterDataVersion = async () => {
    let res = await fetch(SERVER_API("master_data_version"));
    let json = await res.json();
    if (!json.result || !json.result[0]) return true;
    let forced = false;
    if (Object.keys(this.master_data_version).length === 0) {
      forced = true;
    } else if (compareVersions(json.result[0].en, this.master_data_version.en) > 0) {
      forced = true;
    }
    this.master_data_version = json.result[0];
    makePersit.make(this.master_data_version, "master_data_version");
    return forced;
  }

  syncDataServer = async (arr, forced) => {
    if (forced === true) {
      const res = await fetch(SERVER_API_ALL);
      const json = await res.json();

      for (let i=0; i< arr.length; i++) {
        const fieldName = arr[i]
        this[fieldName] = json.result.array[fieldName];
        makePersit.make(this[fieldName], fieldName);
      }
    } else {
      let isLocalEmpty = false;
      for (let i=0; i< arr.length; i++) {
        const fieldName = arr[i];
        let foo = await makePersit.persist(fieldName, "object");
        if (foo != undefined) this[fieldName] = foo;
        else {
          console.log('fieldName', foo);
          isLocalEmpty = true;
          break;
        }
      }
      if (isLocalEmpty) this.syncDataServer(arr, true);
    }
  }
}

export default new FieldStore();


// WEBPACK FOOTER //
// ./src/services/fieldMasterData/fieldMasterData.Store.js